import NewsList from "@/pages/NewsList";
import NewsItem from "@/pages/NewsItem";

export default [
  {
    path: "/news",
    name: "NewsList",
    component: NewsList,
    props: true,
    children: [
      {
        path: "/news/:ident",
        name: "NewsItem",
        component: NewsItem,
        props: true,
      },
    ],
  },
];
